import classNames from 'classnames';
import $ from 'jquery';
import {filter, find, map, orderBy} from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import swal from 'sweetalert2';
import {fetchPlayerPool} from '../../../../../actions/app/playerPool';
import {
  fetchTdsIfNeeded,
  setGroupLocalStorage,
} from '../../../../../actions/app/tools/tds/listWidget';
import {
  championshipsById,
  ChampionshipSelector,
} from '../../../../../components/ChampionshipSelector';
import Icon from '../../../../../components/Icon';
import Loader from '../../../../../components/Loader';
import {
  getEndpoint,
  getHeaders,
  getMPPEndpoint,
} from '../../../../../helpers/endpoint';
import selectEntities from '../../../../../selectors/entities';
import IconManager, {playerStatusById} from './iconManager/index';
import './TdsListWidget.css';

const initialState = {
  selectedPlayerId: undefined,
  championship: 1,
  championshipCalendar: undefined,
  championshipClubsById: undefined,
  selectedGameWeek: undefined,
  filters: {},
  orderBy: 'club',
  sortOrder: 'asc',
  players: undefined,
  focusedInputValue: '',
  groupTeam: '',
  textArea: '',
};

export const changeChampionshipPlayerStatus = payload => {
  return (_dispatch, getState) => {
    fetch(getEndpoint('changeChampionshipPlayerStatus', payload), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({[payload.gameWeekNumber]: payload.status}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          payload.onSuccess && payload.onSuccess();
        }
      });
  };
};

export const updateTdsByGameWeek = payload => {
  return (_dispatch, getState) => {
    fetch(getEndpoint('updateTdsByGameWeek', payload), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          payload.onSuccess && payload.onSuccess();
        }
      });
  };
};

export const getNextGameWeekByChampiomshipId = payload => {
  return (_dispatch, getState) => {
    fetch(
      getEndpoint('getNextGameWeekByChampiomshipId', payload.championshipId),
      {
        method: 'GET',
        headers: getHeaders(getState().authentication),
      },
    )
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          payload.onError();
        } else {
          payload.onSuccess(data);
        }
      });
  };
};

export const getChampionshipClubs = payload => {
  return (_dispatch, getState) => {
    fetch(getEndpoint('getChampionshipClubs'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          payload.onSuccess(data.championshipClubs);
        }
      });
  };
};

export const getChampionshipClubsByChampionshipId = onSuccess => {
  return dispatch => {
    dispatch(
      getChampionshipClubs({
        onSuccess: clubs => {
          const championshipClubsById = {};
          Object.keys(championshipsById).forEach(championshipId => {
            championshipClubsById[championshipId] = filter(
              clubs,
              club =>
                club.championships[championshipId] &&
                club.championships[championshipId].active,
            );
          });
          onSuccess(championshipClubsById, clubs);
        },
      }),
    );
  };
};

export const getChampionshipCalendarByChampionshipId = (payload, isMPP) => {
  const endpoint = isMPP ? getMPPEndpoint : getEndpoint;
  return (_dispatch, getState) => {
    fetch(
      endpoint(
        'getChampionshipCalendarByChampionshipId',
        payload.championshipId,
      ),
      {
        method: 'GET',
        headers: getHeaders(getState().authentication),
      },
    )
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          payload.onSuccess(data);
        }
      });
  };
};

class TdsListWidget extends React.Component {
  constructor(props) {
    super(props);
    const state = initialState;
    this.state = state;
  }

  displayRequestMessage(info = this.props.page.info) {
    if (info.error) {
      switch (info.error) {
        default:
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong with: "${info.lastAction}"<br/>` +
              `<pre><code>${JSON.stringify(info, undefined, 4)}</code></pre>`,
          });
      }
    }
  }

  selectOrChangeOrder(orderType) {
    if (orderType === this.state.orderBy)
      this.setState({
        sortOrder: this.state.sortOrder === 'asc' ? 'desc' : 'asc',
      });
    else {
      this.setState({orderBy: orderType});
      // The switch is necessary for the default sortOrder each orderType
      switch (orderType) {
        case 'club':
          this.setState({sortOrder: 'asc'});
          break;
        case 'name':
          this.setState({sortOrder: 'asc'});
          break;
        case 'position':
          this.setState({sortOrder: 'asc'});
          break;
        case 'quotation':
          this.setState({sortOrder: 'desc'});
          break;
        case 'injured':
          this.setState({sortOrder: 'asc'});
          break;
        case 'suspended':
          this.setState({sortOrder: 'asc'});
          break;
        case 'pending':
          this.setState({sortOrder: 'asc'});
          break;
        case 'reported':
          this.setState({sortOrder: 'asc'});
          break;
        default:
          this.setState({sortOrder: 'asc'});
      }
    }
  }

  orderPlayers(players) {
    const {championshipClubsById} = this.state;
    // The switch is necessary for the default second order of each orderType
    switch (this.state.orderBy) {
      case 'club':
        return orderBy(
          players,
          [
            player =>
              championshipClubsById &&
              championshipClubsById[player.clubId] &&
              championshipClubsById[player.clubId].name['fr-FR'],
            'position',
          ],
          [this.state.sortOrder, 'asc'],
        );
      case 'name':
        return orderBy(
          players,
          ['lastName', 'quotation'],
          [this.state.sortOrder, 'desc'],
        );
      case 'position':
        return orderBy(
          players,
          ['position', 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
      default:
        return orderBy(
          players,
          ['quotation', 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
    }
  }

  getOrderCaret(orderType) {
    if (orderType !== this.state.orderBy) return false;

    return `fa-caret-${this.state.sortOrder === 'desc' ? 'down' : 'up'}`;
  }

  filterPlayers(players) {
    if (this.state.filters.status) {
      players = filter(players, player => {
        if (
          this.props?.page?.data?.gameWeeks?.[this.state.selectedGameWeek]
            ?.playersStatuses?.[player.id] ===
          parseInt(this.state.filters.status, 10)
        ) {
          return player;
        }
      });
    }
    map(this.state.filters, (value, key) => {
      if (value && value !== '') {
        switch (key) {
          case 'name':
            players = filter(players, player =>
              player.lastName.match(new RegExp(value, 'gi')),
            );
            break;
          case 'club':
            players = filter(players, {clubId: value});
            break;
          case 'position':
            players = filter(players, {position: parseInt(value, 10)});
            break;
          case 'quotation':
            players = filter(
              players,
              player => player.quotation >= parseInt(value, 10),
            );
            break;
          default:
            return players;
        }
      }
    });
    return players;
  }

  changeChampionship(championship) {
    this.setState({championship});
    this.resetFilters();
    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: `?championship=${championship}`,
    });
  }

  changePlayerState = (championshipPlayerId, status, value, gameWeekNumber) => {
    const {championship} = this.state;
    this.props.dispatch(
      changeChampionshipPlayerStatus({
        championshipPlayerId,
        status: value ? status : null,
        championshipId: championship,
        gameWeekNumber: gameWeekNumber,
        onSuccess: () => this.fetchTds(championship),
      }),
    );
  };

  fetchTds = (championship, onSuccess) => {
    this.props.dispatch(
      fetchTdsIfNeeded({
        championship,
        onSuccess,
      }),
    );
  };

  fetchAllData = championship => {
    this.props.dispatch(
      getChampionshipCalendarByChampionshipId({
        championshipId: championship,
        onSuccess: championshipCalendar =>
          this.setState({
            championshipCalendar: championshipCalendar.gameWeeks,
          }),
      }),
    );
    this.props.dispatch(
      fetchPlayerPool({
        championship,
        onSuccess: data => {
          this.setState({
            players: this.orderPlayers(
              this.filterPlayers(this.props.playerPool),
            ),
          });
        },
      }),
    );
    this.props.dispatch(
      getNextGameWeekByChampiomshipId({
        championshipId: championship,
        onSuccess: selectedGameWeek => {
          this.fetchTds(championship);
          this.setState({
            selectedGameWeek:
              selectedGameWeek?.gameWeek?.gameWeekNumber || undefined,
          });
        },
        onError: () => {
          this.setState({
            selectedGameWeek: undefined,
          });
        },
      }),
    );
  };

  componentDidMount() {
    const {championship} = this.state;
    this.props.dispatch(
      getChampionshipClubsByChampionshipId(
        (championshipClubsByChampionshipId, clubs) => {
          this.setState({
            championshipClubsById: clubs,
          });
          this.setState({
            championshipClubsByChampionshipId,
          });
        },
      ),
    );
    this.fetchAllData(championship);
  }

  componentDidUpdate(prevProps, prevState) {
    const {championship, orderBy, filters, sortOrder} = this.state;
    if (prevState.championship !== championship) {
      this.fetchAllData(championship);
    }
    if (
      prevProps.page.info.success !== this.props.page.info.success ||
      prevProps.page.info.error !== this.props.page.info.error
    ) {
      this.displayRequestMessage(this.props.info);
    }
    if (
      prevState.orderBy !== orderBy ||
      prevState.sortOrder !== sortOrder ||
      prevState.filters !== filters ||
      (!prevProps.playerPool && this.props.playerPool) ||
      prevState.selectedGameWeek !== this.state.selectedGameWeek
    ) {
      this.setState({
        players: this.orderPlayers(this.filterPlayers(this.props.playerPool)),
      });
    }
  }

  renderNoResult() {
    return (
      !this.props.page.info.isFetching && (
        <div className="no-result text-center">
          <h4 className="text-red">
            <i className="fa fa-meh-o" /> Oh! we couldn't find any players
            corresponding to your request.
          </h4>
        </div>
      )
    );
  }

  renderBody() {
    const {championshipClubsById, players, selectedGameWeek} = this.state;
    const positions = ['Goal Keeper', 'Defender', 'Midfielder', 'Striker'];

    if (!players || (players && Object.keys(players).length < 1))
      return this.renderNoResult();

    return (
      <table className="table table-responsive table-striped">
        <thead>
          <tr>
            <th className="id">ID</th>
            <th>
              <a onClick={() => this.selectOrChangeOrder('name')}>
                Name&nbsp;
                <i className={classNames('fa', this.getOrderCaret('name'))} />
              </a>
            </th>
            <th>
              <a onClick={() => this.selectOrChangeOrder('club')}>
                Club&nbsp;
                <i className={classNames('fa', this.getOrderCaret('club'))} />
              </a>
            </th>
            <th>
              <a onClick={() => this.selectOrChangeOrder('position')}>
                Position&nbsp;
                <i
                  className={classNames('fa', this.getOrderCaret('position'))}
                />
              </a>
            </th>
            <th className="status">
              <div>
                {Object.keys(playerStatusById).map(statusId => (
                  <div className="iconEnable">
                    <Icon type={playerStatusById[statusId]} />
                  </div>
                ))}
              </div>
            </th>
            <th class="text-center">Last Gameweek</th>
          </tr>
        </thead>
        <tbody>
          {map(players, ({id, firstName, lastName, clubId, position}, key) => {
            const playersStatuses =
              this.props?.page?.data?.gameWeeks?.[selectedGameWeek]
                ?.playersStatuses;
            const previousPlayersStatuses =
              this.props?.page?.data?.gameWeeks?.[selectedGameWeek - 1]
                ?.playersStatuses;
            return (
              <tr key={key} id={id}>
                <td className="id">{id}</td>
                <th
                  style={{color: '#3c8dbc', cursor: 'pointer'}}
                  onClick={() => {
                    this.setState({selectedPlayerId: id});
                    $('#tdsChampionshipPlayerStatusByGameWeek').modal('show');
                  }}>
                  {firstName} <span className="text-uppercase">{lastName}</span>
                </th>
                <td data-id={clubId}>
                  {(championshipClubsById[clubId] &&
                    championshipClubsById[clubId].name['fr-FR']) ||
                    '-'}
                </td>
                <td>{positions[position - 1]}</td>
                <th>
                  <div className="status">
                    <IconManager
                      selectedGameWeek={selectedGameWeek}
                      playerId={id}
                      type={playersStatuses && playersStatuses?.[id]}
                      changePlayerState={this.changePlayerState}
                    />
                  </div>
                </th>
                <th class="text-center">
                  <IconManager
                    disabled={true}
                    selectedGameWeek={selectedGameWeek - 1}
                    playerId={id}
                    type={
                      previousPlayersStatuses && previousPlayersStatuses?.[id]
                    }
                  />
                </th>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  resetFilters = () => {
    document.getElementById('filter1').value = '';
    document.getElementById('filter2').value = '';
    document.getElementById('filter3').value = '';
    document.getElementById('filter4').value = '';

    this.setState({
      filters: {},
      orderBy: 'club',
      sortOrder: 'asc',
      groupTeam: '',
    });
  };

  onChangeGroup(value) {
    this.props.dispatch(
      setGroupLocalStorage({
        club: this.state.groupTeam,
        value,
        championship: this.state.championship,
      }),
    );
  }

  renderFilters() {
    const {championshipClubsByChampionshipId, championship} = this.state;
    const clubOptions = orderBy(
      !!championshipClubsByChampionshipId &&
        championshipClubsByChampionshipId[championship],
      [championship => championship.name['fr-FR']],
      ['asc'],
    );

    return (
      <div className="box-footer">
        <div style={{display: 'flex', flexDirection: 'row'}}>
          <div style={{flex: 1, margin: 4}}>
            <input
              id="filter1"
              type="text"
              className="form-control"
              placeholder="Name of a player"
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    name: e.target.value.length > 2 ? e.target.value : '',
                  },
                })
              }
              disabled={this.props.page.info.isFetching}
            />
          </div>
          <div style={{flex: 1, margin: 4}}>
            <select
              id="filter2"
              className="form-control"
              value={this.state.filters.club}
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    club: e.target.value,
                  },
                  groupTeam: e.target.value,
                })
              }
              disabled={this.props.page.info.isFetching}>
              <option value="">All clubs</option>
              {clubOptions.map((club, key) => (
                <option key={key} value={club.id}>
                  {club.name['fr-FR']}
                </option>
              ))}
            </select>
          </div>
          <div style={{flex: 1, margin: 4}}>
            <select
              id="filter3"
              className="form-control"
              value={this.state.filters.position}
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    position: e.target.value,
                  },
                })
              }
              disabled={this.props.page.info.isFetching}>
              <option value="">All positions</option>
              <option value="1">Goal Keepers</option>
              <option value="2">Defenders</option>
              <option value="3">Midfielders</option>
              <option value="4">Strikers</option>
            </select>
          </div>
          <div style={{flex: 1, margin: 4}}>
            <select
              id="filter4"
              className="form-control"
              value={this.state.filters.status}
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    status: e.target.value,
                  },
                })
              }
              disabled={this.props.page.info.isFetching}>
              <option value="">All status</option>
              <option value={2}>Injured</option>
              <option value={3}>Suspended</option>
              <option value={1}>Uncertain</option>
              <option value={6}>Missing</option>
            </select>
          </div>
          <div style={{flex: 1, margin: 4}}>
            <button
              type="button"
              onClick={this.resetFilters}
              className="btn btn-default buttonReset btn-block">
              <i className="fa fa-times" /> Reset filters
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderGameWeekInfos = () => {
    const {selectedGameWeek, championshipCalendar, championship, players} =
      this.state;
    const {dispatch, page} = this.props;
    const allGameWeeksNumber = Object.keys(championshipCalendar);
    const updateTds = () =>
      dispatch(
        updateTdsByGameWeek({
          gameWeekNumber: selectedGameWeek,
          championshipId: championship,
          onSuccess: () => this.fetchTds(championship),
        }),
      );
    const changeSelectedGameWeek = gameWeekNumber =>
      this.setState({
        selectedGameWeek: gameWeekNumber,
      });
    const updatedAt = page?.data?.gameWeeks?.[selectedGameWeek]?.updatedAt;

    return (
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}>
        <i
          onClick={() =>
            championshipCalendar[selectedGameWeek - 1] &&
            changeSelectedGameWeek(selectedGameWeek - 1)
          }
          style={{padding: 16, fontSize: 20, cursor: 'pointer'}}
          className="fa fa-arrow-left text-muted"
        />
        <select
          style={{width: 100, margin: 16}}
          className="form-control"
          onChange={event =>
            changeSelectedGameWeek(parseInt(event.target.value, 10))
          }
          value={selectedGameWeek}>
          {allGameWeeksNumber.map(gameWeekNumber => (
            <option value={gameWeekNumber}>{gameWeekNumber}</option>
          ))}
        </select>
        <i
          onClick={() =>
            championshipCalendar[selectedGameWeek + 1] &&
            changeSelectedGameWeek(selectedGameWeek + 1)
          }
          style={{padding: 16, fontSize: 20, cursor: 'pointer'}}
          className="fa fa-arrow-right text-muted"
        />
        {players || (players && Object.keys(players).length >= 1) ? (
          <>
            {updatedAt ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                <button
                  onClick={updateTds}
                  className="btn"
                  style={{
                    color: '#4054CC',
                    backgroundColor: 'white',
                    borderWidth: 1,
                    borderColor: '#4054CC',
                  }}>{`Mettre à jour J.${selectedGameWeek}`}</button>
                <div style={{marginLeft: 16}}>
                  <span style={{color: '#959DAF'}}>
                    Dernière modification:{' '}
                  </span>
                  <span>{`${moment(updatedAt).format('DD/MM/YY, HH:mm')}`}</span>
                </div>
              </div>
            ) : (
              <div>
                <button
                  onClick={updateTds}
                  className="btn"
                  style={{
                    color: 'white',
                    backgroundColor: '#4054CC',
                  }}>{`Publier J.${selectedGameWeek}`}</button>
              </div>
            )}
          </>
        ) : null}
      </div>
    );
  };

  renderPlayerStatusesModal = () => {
    const {playerPool, page} = this.props;
    const {selectedPlayerId, championshipCalendar} = this.state;
    const player = find(playerPool, {id: selectedPlayerId});
    return (
      <div
        id="tdsChampionshipPlayerStatusByGameWeek"
        class="modal fade"
        role="dialog">
        <div class="modal-dialog">
          <div class="modal-body">
            {selectedPlayerId && player && (
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal">
                    &times;
                  </button>
                  <h4 class="modal-title">
                    {player.firstName}{' '}
                    <span className="text-uppercase">{player.lastName}</span>
                  </h4>
                </div>
                <div class="modal-body">
                  <table className="table table-responsive table-striped">
                    <thead />
                    <tbody>
                      {Object.keys(championshipCalendar).map(gameWeekNumber => (
                        <tr key={gameWeekNumber}>
                          <th>{`J.${gameWeekNumber}`}</th>
                          <th
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}>
                            <div className="status">
                              <IconManager
                                selectedGameWeek={gameWeekNumber}
                                playerId={selectedPlayerId}
                                type={
                                  page.data.gameWeeks[gameWeekNumber] &&
                                  page?.data?.gameWeeks?.[gameWeekNumber]
                                    ?.playersStatuses?.[selectedPlayerId]
                                }
                                changePlayerState={this.changePlayerState}
                              />
                            </div>
                          </th>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {info, data} = this.props.page;
    const {championship, selectedGameWeek} = this.state;

    return (
      <div id="tds-list-widget" className="row">
        <div className="col-md-12">
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-medkit" /> Players list
              </h3>
              <div className="box-tools pull-right">
                <ChampionshipSelector
                  championship={championship}
                  onChange={c => this.changeChampionship(c)}
                />
              </div>
            </div>
            {data && selectedGameWeek && this.renderGameWeekInfos()}
            {this.renderFilters()}
            <div className="box-body">
              {data && selectedGameWeek
                ? this.renderBody()
                : this.renderNoResult()}
            </div>
            {data && selectedGameWeek && this.renderPlayerStatusesModal()}
            {info.isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

TdsListWidget.propTypes = {
  championship: PropTypes.number,
};

export default withRouter(
  connect(
    state => ({
      entities: selectEntities(state.entities.players, state.app.tools.tds.ids),
      playerPool: state.app.playerPool.data,
      page: state.app.tools.tds,
      groupStorage: state.groupStorage,
    }),
    dispatch => ({dispatch}),
  )(TdsListWidget),
);



// WEBPACK FOOTER //
// ./src/pages/Tools/Tds/Widgets/TdsList/index.js